import { SelectionModel } from '@angular/cdk/collections';
import { CdkTableModule } from '@angular/cdk/table';
import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import {
  MatLegacyTableDataSource as MatTableDataSource,
  MatLegacyTableModule as MatTableModule,
} from '@angular/material/legacy-table';
import { OrderDetailService } from '@cutting/main/order/order-detail/order-detail.service';
import { fuseAnimations } from '@fuse/animations';
import { CuttingCuttedMaterial, CuttingOffcut, NgxLocalizedNumbers } from 'cloud-shared-lib';

@Component({
  selector: 'cutting-offcut-list',
  templateUrl: './offcut-list.component.html',
  styleUrls: ['./offcut-list.component.scss'],
  standalone: true,
  imports: [NgClass, NgxLocalizedNumbers, CdkTableModule, MatTableModule, MatCheckboxModule],
  animations: fuseAnimations,
})
export class OffcutListComponent {
  @Input() canTakeAway = true;

  selectedMaterialId = 0;

  displayedColumns = ['takeAway', 'height', 'width', 'count', 'area'];

  dataSource: MatTableDataSource<CuttingOffcut> = new MatTableDataSource();
  selection = new SelectionModel<CuttingOffcut>(true, []);

  @Input() set material(value: CuttingCuttedMaterial) {
    this.selectedMaterialId = value.inMaterialBaseId;

    this.dataSource.data = value.offcuts;
    this.selection.clear();
    this.selection.select(...this.dataSource.data.filter(o => o.takeAway));
  }

  constructor(private orderDetailService: OrderDetailService) {}

  toggleTakeAwayOffcut(item: CuttingOffcut): void {
    this.selection.toggle(item);
    item.takeAway = this.selection.isSelected(item);
    this.orderDetailService.saveOffcuts(this.selectedMaterialId, this.dataSource.data);
  }

  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle(): void {
    if (this.isAllSelected()) {
      this.dataSource.data.forEach(row => ((row.takeAway = false), this.selection.deselect(row)));
    } else {
      this.dataSource.data.forEach(row => ((row.takeAway = true), this.selection.select(row)));
    }

    this.orderDetailService.saveOffcuts(this.selectedMaterialId, this.dataSource.data);
  }

  /**
   * The label for the checkbox on the passed row
   * @param row
   */
  checkboxLabel(row?: CuttingOffcut): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row`;
  }
}
